module.exports = __webpack_public_path__ + "static/media/java.bcfad0f2.svg";